import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./globals.css";
import { ThemeProvider } from "./components/theme-provider.tsx";
import { AuthProvider } from "./hooks/useAuth.tsx";
import { ProvidersProvider } from "./hooks/useProviders.ts";

const isDevelopment = (import.meta as any).env.DEV;

// Conditionally wrap with StrictMode - disable in dev to prevent duplicate messages
const AppWrapper = isDevelopment ? (
  <ProvidersProvider>
    <AuthProvider>
      <ThemeProvider defaultTheme="dark" storageKey="ai-ui-theme">
        <App />
      </ThemeProvider>
    </AuthProvider>
  </ProvidersProvider>
) : (
  <React.StrictMode>
    <ProvidersProvider>
      <AuthProvider>
        <ThemeProvider defaultTheme="dark" storageKey="ai-ui-theme">
          <App />
        </ThemeProvider>
      </AuthProvider>
    </ProvidersProvider>
  </React.StrictMode>
);

ReactDOM.createRoot(document.getElementById("root")!).render(AppWrapper);
